import {APIError} from "v2/api/Records";

export const apiError = (error) => {
  return new APIError({
    message: error.detail,
  });
};

export default {
  apiError,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Errors.js
 **/